export default "__VITE_ASSET__8cff688f__"